import React from "react";
import getClassNameFactory from "../../utilities/classNames";
import { VerticalSpacingSizes } from "../../core";

var VerticalSpacing = function VerticalSpacing(_ref) {
  var children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? VerticalSpacingSizes.M : _ref$size;
  var getClassName = getClassNameFactory(VerticalSpacing.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      modifiers: size
    })
  }, children);
};

VerticalSpacing.displayName = "VerticalSpacing";
export default VerticalSpacing;